import React from 'react';
import { copyTextToClipboard } from '../../utils/utilities';
import { showSuccessToast } from '../ToastMessage';
import { toAbsoluteUrl } from '../../utils';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

interface IScriptComponentProps {
	title?: string;
	script?: string;
	copy?: boolean;
	additionalClass?: string;
}

export const ScriptComponent = (props: IScriptComponentProps): JSX.Element => {
	const { title, script, copy, additionalClass } = props;
	const { t } = useTranslation();
	const handleClick = (): void => {
		copyTextToClipboard(script);
		showSuccessToast(t('SENSE_JS.TOAST_MESSAGE'));
	};

	return (
		<div className="d-none d-md-block">
			{
				title && (
					<div className="fw-bold fs-2 mb-10">
						{title}
					</div>
				)
			}
			<div className="sense-script position-relative card-body">
        <pre className={clsx('code-area', additionalClass)}>
            {script}
        </pre>
				{
					copy && (
						<div
							className="position-absolute icon-copy cursor-pointer"
							onClick={handleClick}
						>
							<img src={toAbsoluteUrl('/media/icons/copy.svg')} width="12px" height="15px" alt="copy"/>
							<span className="text-danger fw-bolder fs-6 ms-2">
                {t('SENSE_JS.COPY')}
              </span>
						</div>
					)
				}

			</div>
		</div>
	);
};
